export const STARTPAGE_ROUTE = '/';
export const ME_ROUTE = '/links';